import React from 'react';
import {lazy} from 'react';
import {Outlet} from 'react-router-dom';
// layouts
import CompactLayout from 'packages/common/layouts/compact';
import LargeLayout from 'packages/common/layouts/large';

// ----------------------------------------------------------------------

const TermsOfServicePage = lazy(() => import('apps/dashboard/pages/legal/view/TermsOfServicePage'));
const PrivacyPolicyPage = lazy(() => import('apps/dashboard/pages/legal/view/PrivacyPolicyPage'));
const Page403 = lazy(() => import('apps/dashboard/pages/error/view/403Page'));
const Page404 = lazy(() => import('apps/dashboard/pages/error/view/404Page'));
const Page503 = lazy(() => import('apps/dashboard/pages/error/view/503Page'));
const StripeSuccess = lazy(() => import('apps/dashboard/pages/app/company/view/StripeSuccessPage'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      {path: '403', element: <Page403 />},
      {path: '404', element: <Page404 />},
      {path: 'maintenance', element: <Page503 />},
      {path: 'stripe-success', element: <StripeSuccess />},
    ],
  },
  {
    element: (
      <LargeLayout>
        <Outlet />
      </LargeLayout>
    ),
    children: [
      {path: 'terms-of-service', element: <TermsOfServicePage />},
      {path: 'privacy-policy', element: <PrivacyPolicyPage />},
    ],
  },
];
